/* ============================================================
   DECANTS ARGENTINA — FX ENGINE v2 (premium · 3D · WebGL)
   vanilla, dynamic Three.js load. Respeta reduced-motion + touch.
   ============================================================ */
(function(){
  "use strict";
  var RM = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var TOUCH = matchMedia("(hover: none)").matches || ("ontouchstart" in window);
  // progressive enhancement: el CSS solo oculta .da-reveal si esta clase existe
  try{ document.documentElement.classList.add("da-fx"); }catch(e){}
  // red de seguridad: revelar todo lo que quede oculto tras 3.2s (si IO falló)
  setTimeout(function(){ try{ document.querySelectorAll(".da-reveal:not(.is-in), .da-kinetic:not(.is-in)").forEach(function(e){e.classList.add("is-in");}); }catch(e){} }, 3200);
  var lerp=function(a,b,n){return (1-n)*a+n*b;};

  /* ---- Scroll reveals + kinetic ---- */
  function initReveals(){
    var els=document.querySelectorAll(".da-reveal, .da-kinetic");
    if(!("IntersectionObserver" in window)||RM){els.forEach(function(e){e.classList.add("is-in");});return;}
    var io=new IntersectionObserver(function(ents){ents.forEach(function(en){if(en.isIntersecting){var t=en.target;t.classList.add("is-in");io.unobserve(t);
      // perf: liberar will-change tras revelar (no dejar capas de composición permanentes)
      t.addEventListener("transitionend",function clr(){t.style.willChange="auto";},{once:true});
    }});},{threshold:.16,rootMargin:"0px 0px -8% 0px"});
    els.forEach(function(e){
      if(e.classList.contains("da-kinetic")&&!e.dataset.daSplit){
        e.dataset.daSplit="1";var words=e.textContent.trim().split(/\s+/);e.textContent="";
        words.forEach(function(w,i){var s=document.createElement("span");s.className="w";s.textContent=w;s.style.transitionDelay=(i*0.06)+"s";e.appendChild(s);e.appendChild(document.createTextNode(" "));});
      }
      io.observe(e);
    });
  }

  /* ---- 3D tilt + cursor glow ---- */
  function initTilt(){
    if(RM||TOUCH) return;
    document.querySelectorAll(".da-tilt").forEach(function(card){
      if(card.dataset.daTiltInit) return; card.dataset.daTiltInit="1";
      var inner=card.querySelector(".da-tilt__inner")||card, max=parseFloat(card.dataset.tilt||"9");
      card.addEventListener("pointermove",function(e){
        var r=card.getBoundingClientRect(),px=(e.clientX-r.left)/r.width,py=(e.clientY-r.top)/r.height;
        inner.style.transform="perspective(900px) rotateX("+((0.5-py)*max)+"deg) rotateY("+((px-0.5)*max)+"deg) translateZ(14px)";
        card.style.setProperty("--mx",(px*100)+"%");card.style.setProperty("--my",(py*100)+"%");
      });
      card.addEventListener("pointerleave",function(){inner.style.transform="";});
    });
  }

  /* ---- Parallax + scroll cinematics ---- */
  function initParallax(){
    if(RM||window.__daParallaxInit) return; window.__daParallaxInit=1;
    var nodes=[].slice.call(document.querySelectorAll(".da-parallax"));
    var scn=[].slice.call(document.querySelectorAll("[data-da-scroll]"));
    if(!nodes.length&&!scn.length) return;
    var mx=0,my=0,tmx=0,tmy=0,ticking=false;
    function raf(){
      tmx=lerp(tmx,mx,.08);tmy=lerp(tmy,my,.08);
      nodes.forEach(function(n){
        var d=parseFloat(n.dataset.depth||"0.1"),rect=n.getBoundingClientRect();
        var center=(rect.top+rect.height/2-window.innerHeight/2),ty=-center*d*0.12;
        n.style.transform="translate3d("+(tmx*d*24).toFixed(1)+"px,"+(ty+tmy*d*24).toFixed(1)+"px,0)";
      });
      scn.forEach(function(n){
        var r=n.getBoundingClientRect(),vh=window.innerHeight;
        var p=Math.max(0,Math.min(1,1-(r.top+r.height*0.2)/(vh+r.height*0.4)));
        var sc=parseFloat(n.dataset.scrollScale||"0"),ro=parseFloat(n.dataset.scrollRot||"0"),tr=parseFloat(n.dataset.scrollY||"0");
        n.style.transform="translateY("+((1-p)*tr).toFixed(1)+"px) scale("+(1+(p-1)*-sc).toFixed(3)+") rotate("+((1-p)*ro).toFixed(2)+"deg)";
        if(n.dataset.scrollFade) n.style.opacity=(0.3+0.7*p).toFixed(2);
      });
      ticking=false;
    }
    function tick(){if(!ticking){ticking=true;requestAnimationFrame(raf);}}
    window.addEventListener("scroll",tick,{passive:true});
    if(!TOUCH) window.addEventListener("pointermove",function(e){mx=(e.clientX/innerWidth-.5);my=(e.clientY/innerHeight-.5);},{passive:true});
    (function loop(){raf();requestAnimationFrame(loop);})();
  }

  /* ---- Page movement: scroll-velocity skew + float ---- */
  function initMovement(){
    if(RM||window.__daMovementInit) return; window.__daMovementInit=1;
    // skew/scale por velocidad de scroll en imágenes y elementos marcados
    var targets=[].slice.call(document.querySelectorAll(".da-skew, [data-da-skew]"));
    var last=window.scrollY, vel=0;
    function loop(){
      var now=window.scrollY, dv=now-last; last=now;
      vel=lerp(vel, dv, .12);
      var sk=Math.max(-7,Math.min(7, vel*0.35));
      var sc=1+Math.min(.05,Math.abs(vel)*0.0016);
      targets.forEach(function(t){ t.style.transform="skewY("+sk.toFixed(2)+"deg) scale("+sc.toFixed(3)+")"; });
      requestAnimationFrame(loop);
    }
    if(targets.length) requestAnimationFrame(loop);
  }

  /* ---- Magnetic buttons ---- */
  function initMagnetic(){
    if(RM||TOUCH) return;
    document.querySelectorAll(".da-magnetic, .da-btn--gold").forEach(function(el){
      if(el.dataset.daMagInit) return; el.dataset.daMagInit="1";
      // seguir el cursor crisp; el spring-back usa la transición .35s del CSS
      el.addEventListener("pointerenter",function(){el.style.transition="transform .08s linear";});
      el.addEventListener("pointermove",function(e){
        var r=el.getBoundingClientRect();
        el.style.transform="translate("+((e.clientX-r.left-r.width/2)*.28).toFixed(1)+"px,"+((e.clientY-r.top-r.height/2)*.32).toFixed(1)+"px)";
      });
      el.addEventListener("pointerleave",function(){el.style.transition="";el.style.transform="";});
    });
  }

  /* ---- Countdown + count-up ---- */
  function initCountdowns(){
    var els=document.querySelectorAll("[data-da-countdown]");if(!els.length)return;
    function pad(n){return (n<10?"0":"")+n;}
    function upd(){var now=new Date();els.forEach(function(el){var m=el.getAttribute("data-da-countdown"),end;if(m==="eod"){end=new Date(now);end.setHours(23,59,59,0);}else end=new Date(m);var s=Math.max(0,Math.floor((end-now)/1000));el.textContent=pad(Math.floor(s/3600))+":"+pad(Math.floor(s%3600/60))+":"+pad(s%60);});}
    upd();setInterval(upd,1000);
  }
  function initCountUp(){
    var els=document.querySelectorAll("[data-da-countup]");if(!els.length)return;
    if(!("IntersectionObserver" in window)){els.forEach(function(e){e.textContent=(+e.getAttribute("data-da-countup")).toLocaleString("es-AR");});return;}
    var io=new IntersectionObserver(function(ents){ents.forEach(function(en){if(!en.isIntersecting)return;var el=en.target,t=parseFloat(el.getAttribute("data-da-countup")),t0=null,dur=RM?0:1500;function st(ts){if(!t0)t0=ts;var p=Math.min(1,(ts-t0)/dur);el.textContent=Math.floor((1-Math.pow(1-p,3))*t).toLocaleString("es-AR");if(p<1)requestAnimationFrame(st);else el.textContent=t.toLocaleString("es-AR");}requestAnimationFrame(st);io.unobserve(el);});},{threshold:.6});
    els.forEach(function(e){io.observe(e);});
  }

  /* ---- WebGL gold particle field (Three.js, lazy) ---- */
  function initThree(){
    var canvases=document.querySelectorAll("canvas[data-da-three]");
    if(!canvases.length) return;
    // perf: en reduced-motion Y en touch/móvil NO cargamos Three.js (~600KB) — el hero ya luce premium con imagen+godrays+grain+degradado
    if(RM||TOUCH){canvases.forEach(function(c){c.style.display="none";});return;}
    function build(){
      canvases.forEach(function(canvas){
        var THREE=window.THREE;if(!THREE)return;
        if(canvas.dataset.daThreeInit)return; canvas.dataset.daThreeInit="1";
        var w=canvas.clientWidth,h=canvas.clientHeight;
        // Crear el renderer. Si WebGL no está disponible (gama baja), solo se aborta: el canvas
        // queda transparente e invisible — NO se oculta. Ocultarlo no aporta nada y un fallo
        // transitorio de contexto "quemaba" el canvas y tumbaba la animación en equipos válidos.
        // Tampoco se pre-testea WebGL (ese atajo cosmético daba falsos negativos). Solo se captura
        // la excepción para que no quede como Uncaught.
        var renderer;
        try{ renderer=new THREE.WebGLRenderer({canvas:canvas,alpha:true,antialias:true}); }
        catch(e){ return; }
        if(!renderer){ return; }
        renderer.setPixelRatio(Math.min(devicePixelRatio,2));renderer.setSize(w,h,false);
        var scene=new THREE.Scene();
        var cam=new THREE.PerspectiveCamera(60,w/h,.1,100);cam.position.z=14;
        // partículas doradas
        var N=TOUCH?260:560,geo=new THREE.BufferGeometry(),pos=new Float32Array(N*3),sz=new Float32Array(N);
        for(var i=0;i<N;i++){pos[i*3]=(Math.random()-.5)*32;pos[i*3+1]=(Math.random()-.5)*22;pos[i*3+2]=(Math.random()-.5)*22;sz[i]=Math.random()*2+.5;}
        geo.setAttribute("position",new THREE.BufferAttribute(pos,3));
        geo.setAttribute("asize",new THREE.BufferAttribute(sz,1));
        var sprite=(function(){var c=document.createElement("canvas");c.width=c.height=64;var g=c.getContext("2d");var grd=g.createRadialGradient(32,32,0,32,32,32);grd.addColorStop(0,"rgba(255,236,180,1)");grd.addColorStop(.3,"rgba(228,203,134,.8)");grd.addColorStop(1,"rgba(201,162,75,0)");g.fillStyle=grd;g.fillRect(0,0,64,64);var t=new THREE.CanvasTexture(c);return t;})();
        var mat=new THREE.PointsMaterial({size:.5,map:sprite,transparent:true,depthWrite:false,blending:THREE.AdditiveBlending,color:0xE4CB86,opacity:.9});
        var pts=new THREE.Points(geo,mat);scene.add(pts);
        // halo glow plano
        var glowMat=new THREE.SpriteMaterial({map:sprite,color:0xC9A24B,transparent:true,opacity:.5,blending:THREE.AdditiveBlending,depthWrite:false});
        var glow=new THREE.Sprite(glowMat);glow.scale.set(26,26,1);glow.position.set(6,4,-6);scene.add(glow);
        var mx=0,my=0,running=true;
        if(!TOUCH)window.addEventListener("pointermove",function(e){mx=(e.clientX/innerWidth-.5);my=(e.clientY/innerHeight-.5);},{passive:true});
        var io=new IntersectionObserver(function(en){running=en[0].isIntersecting;if(running)anim();});io.observe(canvas);
        document.addEventListener("visibilitychange",function(){running=!document.hidden;if(running)anim();});
        function resize(){w=canvas.clientWidth;h=canvas.clientHeight;cam.aspect=w/h;cam.updateProjectionMatrix();renderer.setSize(w,h,false);}
        window.addEventListener("resize",resize);
        var t=0,req;
        function anim(){if(!running){cancelAnimationFrame(req);return;}t+=.0016;pts.rotation.y=t*.6;pts.rotation.x=Math.sin(t*.5)*.1;cam.position.x=lerp(cam.position.x,mx*4,.04);cam.position.y=lerp(cam.position.y,-my*3,.04);cam.lookAt(0,0,0);renderer.render(scene,cam);req=requestAnimationFrame(anim);}
        anim();
      });
    }
    if(window.THREE){build();return;}
    var s=document.createElement("script");
    s.src="https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js";
    s.onload=build;s.onerror=function(){canvases.forEach(function(c){c.style.display="none";});};
    document.head.appendChild(s);
  }

  function boot(){initReveals();initTilt();initParallax();initMovement();initMagnetic();initCountdowns();initCountUp();initThree();}
  if(document.readyState!=="loading")boot();else document.addEventListener("DOMContentLoaded",boot);
  document.addEventListener("shopify:section:load",boot);
})();
